import {
    DockingPanel,
    GridApi,
} from '@instinet-analytics/semantic-ui-components';
import IndexEventsGrid from './grid/IndexEventsGrid';
import { useCallback, useState } from 'react';
import { IndexRebalanceEvent } from 'widgets/indexEvents/api/IndexEventsResponse.ts';
import { useWidgetWithDockablePanelDimensions } from 'widgets/utils/useWidgetWithDockablePanelDimensions.ts';
import { initialIndexEventsConfiguration } from 'widgets/indexEvents/store/config/IndexEventsWidgetConfigState.ts';
import { IndexEventsWidgetDetails } from 'widgets/indexEvents/components/IndexEventsWidgetDetails';

const IndexEventsWidgetContent = ({
    onGridApiSet,
}: {
    onGridApiSet: (gridApi: GridApi) => void;
}) => {
    const [selectedIndexEvent, setSelectedIndexEvent] = useState<
        IndexRebalanceEvent | undefined
    >();

    const {
        mainPanelHeight,
        dockablePanelHeight,
        dockablePanelWidth,
        dockablePanelFirst,
        percentage,
        position,
        handlePercentageChange,
    } = useWidgetWithDockablePanelDimensions({
        showDockablePanel: !!selectedIndexEvent,
        tallPanelHeader: true,
        initialConfig: initialIndexEventsConfiguration,
    });

    const onRowSelected = useCallback(
        (row: IndexRebalanceEvent | undefined) => {
            setSelectedIndexEvent(row);
        },
        []
    );

    return (
        <div className="IndexEventsWidgetContent">
            <DockingPanel
                percentage={percentage}
                onPercentageChange={handlePercentageChange}
                position={position}
            >
                {dockablePanelFirst && selectedIndexEvent && (
                    <IndexEventsWidgetDetails
                        height={dockablePanelHeight}
                        width={dockablePanelWidth}
                        indexEvent={selectedIndexEvent}
                    />
                )}
                <IndexEventsGrid
                    height={mainPanelHeight}
                    onGridApiSet={onGridApiSet}
                    onRowSelected={onRowSelected}
                />
                {!dockablePanelFirst && selectedIndexEvent && (
                    <IndexEventsWidgetDetails
                        height={dockablePanelHeight}
                        width={dockablePanelWidth}
                        indexEvent={selectedIndexEvent}
                    />
                )}
            </DockingPanel>
        </div>
    );
};

export default IndexEventsWidgetContent;
